import { EntityUnionType } from 'common/types/entities/EntityInterface'
import { usePage } from 'publisher/store'
import { pageActions } from 'publisher/store/page/pageActions'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const DEFAULT_KEYS = ['popupId']

export const useRemoveUnavailablePopups = <
  Entity extends (Record<Keys, string | null> | Partial<Record<Keys, string>>) &
    EntityUnionType,
  Keys extends string = 'popupId',
>({
  keys = DEFAULT_KEYS as Keys[],
  entity,
  removeType = 'delete',
}: {
  keys?: Keys[]
  entity: Entity
  removeType?: 'delete' | 'setToNull'
}) => {
  const dispatch = useDispatch()
  const popupEntities = usePage(pageState =>
    pageSelectors.getWebsiteGlobalOrPagePopupEntities(pageState)(entity),
  )

  useEffect(() => {
    const newEntity = {
      ...entity,
    }
    let needUpdate = false
    keys.forEach(key => {
      // remove popup if it is not available
      if (!popupEntities.find(popup => popup.id === newEntity[key])) {
        needUpdate = true
        if (removeType === 'delete') {
          delete newEntity[key]
        } else {
          newEntity[key] = null as Entity[Keys]
        }
      }
    })
    if (needUpdate) {
      dispatch(pageActions.updateEntity(newEntity))
    }
  }, [
    removeType,
    popupEntities.length,
    keys.length,
    ...keys.map(key => entity[key]),
  ])
}
